/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconMapPause = createReactComponent("outline", "map-pause", "IconMapPause", [["path", { "d": "M13 19l-4 -2l-6 3v-13l6 -3l6 3l6 -3v9", "key": "svg-0" }], ["path", { "d": "M9 4v13", "key": "svg-1" }], ["path", { "d": "M15 7v6.5", "key": "svg-2" }], ["path", { "d": "M17 17v5", "key": "svg-3" }], ["path", { "d": "M21 17v5", "key": "svg-4" }]]);

export { IconMapPause as default };
//# sourceMappingURL=IconMapPause.mjs.map
